import { GenericResponse } from "@/common/common_utils";
import { ENDPOINTS } from "@/constants/endpoints";
import { axiosInstance } from "@/services/axios.service";
import { useAuthenticationStore } from "@/store";
import { BaseResponse, GetOnboardingStepsResponse, OnboardingStep, UpdateOnboardingStepRequest } from "@/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export const useOnboardingState = () => {
	const stepsQ = useOnboardingSteps();
	const completeStepMutation = useCompleteOnboardingStep();

	return { stepsQ, completeStepMutation };
};

export const useOnboardingSteps = () => {
	const accessToken = useAuthenticationStore((state) => state.accessToken);

	return useQuery({
		queryKey: ['onboarding-steps', accessToken],
		queryFn: async () => {
			const response = await axiosInstance.post<GenericResponse<GetOnboardingStepsResponse>>(ENDPOINTS['/api/X4bUser/GetOnboardingSteps']);
			return response.data.Data;
		},
		staleTime: 5 * 60 * 1000,
	});
}

export const useCompleteOnboardingStep = () => {
	const accessToken = useAuthenticationStore((state) => state.accessToken);
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (step: OnboardingStep) => {
			await axiosInstance.post<BaseResponse, AxiosResponse<BaseResponse>, UpdateOnboardingStepRequest>(
				ENDPOINTS['/api/X4bUser/UpdateOnboardingSteps'],
				{ Step: OnboardingStep[step] }
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['onboarding-steps', accessToken] });
		},
	});
}
